import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ModerationOperators, ModerationTransitions } from '../../../../../../models';

import { SelectHierarchy, Section, Icon, Button, ToastContext } from '@weezevent/nacre';

import LoadingCard from '../../../../../../components/loadingCard';

import Styles from '../transitionDetails.module.css';

export default function OperatorsStep({ organizationId, flowId, form, setForm, onCardDone, transitionExists }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const history = useHistory();

    const [operators, loadingOperators] = ModerationOperators.useApiModel(
        {
            organizationId,
            flowId
        },
        [organizationId, flowId]
    );

    const operatorsOptions = React.useMemo(() => {
        if (!operators || loadingOperators) {
            return [];
        }
        return operators
            .map(operator => ({
                text: operator.email,
                key: operator.username,
                value: operator.id
            }))
            .sort((a, b) => a.text.localeCompare(b.text));
    }, [operators, loadingOperators]);

    const operatorsLabel = React.useMemo(() => {
        if (!form.allowed_users?.length) return null;
        if (form.allowed_users?.length !== operators?.length) {
            return t('ticket.moderation.statusesTransitions.transition.steps.operators.labelCount', { count: form.allowed_users?.length });
        }
        return t('ticket.moderation.statusesTransitions.transition.steps.operators.labelCountAll');
    }, [form, operators]);

    const operatorRemove = React.useCallback(
        index => {
            const arr = [...form.allowed_users];
            arr.splice(index, 1);
            setForm('allowed_users', arr);
        },
        [form]
    );

    const handleSubmit = React.useCallback(() => {
        let transition = new ModerationTransitions({ ...form, allowed_users: form.allowed_users });
        transition
            .save({ organizationId, flowId })
            .then(() => {
                toast.success(t('ticket.moderation.statusesTransitions.transition.steps.operators.messageSuccessSave'));
                history.push(`/ticket/O${organizationId}/moderation/moderation_flows/${flowId}/statuses_transitions/transitions`);
            })
            .catch(() => {
                toast.error(t('ticket.moderation.statusesTransitions.transition.steps.operators.messageErrorSave'));
            });
    }, [form, organizationId, flowId]);

    return (
        <>
            <SelectHierarchy
                multi
                options={operatorsOptions}
                placeholder={t('ticket.common.action.select')}
                labelApply={t('ticket.common.action.select')}
                labelSelectAll={t('ticket.common.action.select-all')}
                onChange={value => setForm('allowed_users', value)}
                selected={form.allowed_users}
                value={operatorsLabel}
            />
            {!!form.allowed_users?.length && (
                <Section className={Styles['operator-lines-container']}>
                    <span>{t('ticket.moderation.statusesTransitions.transition.steps.operators.allowed')}</span>
                    <LoadingCard loading={loadingOperators} className={Styles['loading-card']}>
                        {operators
                            ?.filter(operator => form.allowed_users.includes(operator.id))
                            .map((operator, index) => (
                                <div key={operator.id} className={Styles['operator-line']}>
                                    <span>{operator.email}</span>
                                    <Icon name="trash" onClick={() => operatorRemove(index)} />
                                </div>
                            ))}
                    </LoadingCard>
                </Section>
            )}
            {!transitionExists && <Button className={Styles['operator-savecta']} primary label={t('ticket.common.action.save')} onClick={handleSubmit} />}
        </>
    );
}
